import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { DriverWeekView, driverWeekSearchShape } from "../../components/transport-fleet";
import { useGamesTimeZone } from "../../components/travel-leg-form";
import { useDefaultGamesId } from "../../lib/competition/games";
import { canSeeFleet } from "../../lib/transport/access";

/** A driver's week (S5's `DriverWeekView`, her `#/tpdrv/<id>`); it sets the page bar itself. */
export const Route = createFileRoute("/_app/logistics/transportation/drivers/$driverId")({
	validateSearch: z.object(driverWeekSearchShape),
	beforeLoad: ({ context }) => {
		if (!canSeeFleet(context.session)) throw redirect({ to: "/logistics/transportation" });
	},
	component: DriverWeekPage,
});

function DriverWeekPage() {
	const { session } = Route.useRouteContext();
	const { driverId } = Route.useParams();
	const search = Route.useSearch();
	const navigate = Route.useNavigate();
	const timeZone = useGamesTimeZone(useDefaultGamesId(search.games_id));
	if (!timeZone) return <div className="skeleton h-[20rem] rounded-[0.625rem]" aria-busy />;
	return (
		<DriverWeekView
			driverId={driverId}
			session={session}
			timeZone={timeZone}
			week={search.week}
			onWeek={(week: string | undefined) => void navigate({ search: (s) => ({ ...s, week }), replace: true })}
		/>
	);
}
